import RestfulProvider from "../globals/RestfulProvider";

const headers = {
  Accept: "application/json",
  "Content-type": "application/json",
  isAuthenticated: true,
};
const subUrllocal = "/api/v1/template";
class TemplateServices {
  gettemplateAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/templates`, data, headers);
  createtemplateAPI = (data) =>
    RestfulProvider.post(`${subUrllocal}/create`, data, headers);
  deletetemplateApi = (data) =>
    RestfulProvider.deleteget(`${subUrllocal}/delete`, data, headers);
}
// eslint-disable-next-line
export default new TemplateServices();
